import { useQuery } from "@tanstack/react-query"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
import type { AccessManagementSearchParamsType } from "@/types/access-management"
import { StringHelper } from "@/utils"
const getAccessManagerUsers = async (
  params: AccessManagementSearchParamsType,
) => {
  const queryString = StringHelper.objectToQueryString(params)
  const url = `${ENDPOINTS.USERS}?${queryString}`
  const { data } = await api.get<NewUserResponseType>(url)
  return data
}
const useAccessManagement = (params: AccessManagementSearchParamsType) => {
  return useQuery({
    queryKey: [ENDPOINTS.USERS, params],
    queryFn: () => getAccessManagerUsers(params),
  })
}
export default useAccessManagement
